import { render } from "./ProjectSettings.vue?vue&type=template&id=4bafa481&scoped=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"

import "./ProjectSettings.vue?vue&type=style&index=0&id=4bafa481&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bafa481"]])

export default __exports__